import * as React from 'react';
import {DynamicDatagrid, IDataGridProps, MuiDataGrid, Paper, Checkbox} from "@leap4/frontend";

import {ScrapingUtils} from "../../../../../utils/scraping.utils";
import {Link} from "react-router-dom";
import {urlService} from "../../../../routing/urlsService";
import {IConnectedTag} from "../interfaces/IPublisherTagPage";
import PercentCell from "../../../../shared/PercentCell/PercentCell";
type GridColDef = MuiDataGrid.GridColDef;
type GridRenderCellParams = MuiDataGrid.GridRenderCellParams;

const CheckboxTableCell = ({handleChange}: { handleChange: Function }) => {
    const [checked, setChecked] = React.useState(false);
    const handleChangeHook = (event: React.ChangeEvent<HTMLInputElement>) => {
        setChecked(event.target.checked);
        handleChange(event.target.checked);
    };
    return <Checkbox
        checked={checked}
        onChange={handleChangeHook}
        inputProps={{'aria-label': 'controlled'}}
    />
}

export interface IRowConnectedTag {
    id: string
    name: string
    campaignId: string
    revenue: number,
    impressions: number,
    dataPoint: string
}

export interface IPublisherTagTotals {
    revenue: number;
    impressions: number;
}

export interface IPublisherTagData {
    campaignId: string;
    totals: IPublisherTagTotals;
}

export interface IItems {
    tags: IConnectedTag[];
    publisherTags: IPublisherTagData[];
}

export interface ITagsTableProps extends Partial<IDataGridProps> {
    items: IItems,
    loading: boolean,
}

export default function TagsTable({items, loading, refreshFunc}: ITagsTableProps) {
    const align = 'left'
    const columns: GridColDef[] = [
        {
            field: 'name',
            headerName: 'Name',
            width: 500,
            renderCell: (params: GridRenderCellParams) => {
                return <Link to={urlService.adServerTag((params as any).id, true)}>
                    <strong

                    >{(params as any).formattedValue}</strong></Link>
            }

        },
        {
            field: 'campaignId',
            headerName: 'Campaign ID',
            width: 200,
        },
        {
            field: 'revenue',
            headerName: 'Revenue',
            type: 'number',
            width: 150,
            align,
            headerAlign: align,
            renderCell: (params) => {
                return ScrapingUtils.addSignsToMetricValue('revenue', params.value as number)
            }
        },
    ];
    if (items.publisherTags){
        columns.push(
            {
                field: 'publisherRevenue',
                headerName: 'Publisher Revenue',
                type: 'number',
                width: 200,
                align,
                headerAlign: align,
                renderCell: (params) => {
                    return ScrapingUtils.addSignsToMetricValue('revenue', params.value as number)
                }
            },
            {
                field: 'revenueDifference',
                headerName: '',
                type: 'number',
                width: 150,
                align,
                headerAlign: align,
                renderCell: (params) => {
                    return params.value ? <PercentCell percent={params.value as number}/> : ""
                }
            }

        )
    }
    columns.push({
        field: 'impressions',
        headerName: 'Impressions',
        type: 'number',
        width: 150,
        align,
        headerAlign: align,
        renderCell: (params) => {
            return ScrapingUtils.addSignsToMetricValue('impressions', params.value as number)
        }
    })
    if (items.publisherTags) {
        columns.push(
            {
                field: 'publisherImpressions',
                headerName: 'Publisher Impressions',
                type: 'number',
                width: 200,
                align,
                headerAlign: align,
                renderCell: (params) => {
                    return ScrapingUtils.addSignsToMetricValue('impressions', params.value as number)
                }
            },
            {
                field: 'impressionsDifference',
                headerName: '',
                type: 'number',
                width: 150,
                align,
                headerAlign: align,
                renderCell: (params) => {
                    return params.value ? <PercentCell percent={params.value as number}/> : ""
                }
            })
    }
    columns.push(
        {
            field: 'dataPoint',
            headerName: 'Data Point ',
            width: 160,
            renderCell: (params: GridRenderCellParams) => {
                return <Link to={urlService.dataPointOverview((params as any).id, true)}>
                    <strong
                    >{(params as any).formattedValue}</strong></Link>
            }
        })

    function createRowData(item: (IConnectedTag | IPublisherTagData)): IRowConnectedTag {
        const itemConnectedTag = item as IConnectedTag;
        const baseObj = {
            id: itemConnectedTag._id,
            name: itemConnectedTag.tag.name,
            campaignId: itemConnectedTag.tag.campaignId,
            revenue: itemConnectedTag.revenue,
            impressions: itemConnectedTag.impressions,
            dataPoint: itemConnectedTag.tag.dataPoint.name,
        }
        const publisherTagData = item as any
        if (publisherTagData.publisherRevenue && publisherTagData.publisherImpressions) {
            baseObj["publisherRevenue"] = publisherTagData.publisherRevenue;
            baseObj["publisherImpressions"] = publisherTagData.publisherImpressions;
            baseObj["revenueDifference"] = publisherTagData.publisherRevenue? (100* (publisherTagData.publisherRevenue - itemConnectedTag.revenue)/ publisherTagData.publisherRevenue).toFixed(2): null
            baseObj["impressionsDifference"] = publisherTagData.publisherImpressions? (100* (publisherTagData.publisherImpressions - itemConnectedTag.impressions)/ publisherTagData.publisherImpressions).toFixed(2):null
        }
        return baseObj;
    }

    const publisherTags = items.publisherTags as IPublisherTagData[]
    const rows = items.tags.map((row,) => {
            let fixedRow = row;
            if (publisherTags && publisherTags.length > 0) {
                const matchingPublisherTag = publisherTags.find(tag => tag.campaignId === row.tag.campaignId)
                fixedRow["publisherRevenue"] = matchingPublisherTag.totals.revenue;
                fixedRow["publisherImpressions"] = matchingPublisherTag.totals.impressions;
            }
            return createRowData(fixedRow)
        }
    ).sort((a, b) => b.revenue > a.revenue ? 1 : -1);

    return (
        <Paper sx={{margin: "20px 0", borderRadius: "16px", boxShadow: 'none'}} elevation={5}>
            <DynamicDatagrid rows={rows}
                             columns={columns}
                             loading={loading}
                             loadError={false}
                             refreshFunc={refreshFunc}
                             pageSize={100}
                             style={{minHeight: `75vh`, width: '100%'}}
            />
        </Paper>
    );
}
